module.exports = __webpack_public_path__ + "static/media/au.95735e20.svg";